import { Usuario } from './usuario.model';
import {TablaDeEvaluacion} from './tabla-de-evaluacion.model';
import {MarcoDeReferencia} from './marco-de-referencia.model';
import { Cliente } from './cliente.model';
import { TablaDeEvaluacionDebidaDiligencia } from './tabla-de-evaluacion-debida-diligencia.model';
import { MarcoDeReferenciaDebidaDiligencia } from './marco-de-referencia-debida-diligencia.model';
import { Destinatario } from './destinatario.model';
import { Formulario } from './formulario.model';
import { PersonaFormulario } from './persona-formulario.model';
import { Tipo } from './formulario-item.model';
import { TipoOperacion } from './tipo-operacion.model';
import { SectorActividad } from './sector-actividad.model';
import { Moneda } from './moneda.model';
import { Pais } from './pais.model';
import {PersonaFisica} from './persona-fisica.model';
import {PersonaJuridica} from './persona-juridica.model';


export class DebidaDiligencia
{
    id: number;
    nombre: string;
    tipo: string;
    cliente: Cliente;
    responsable: Usuario;
    estado: string;
    conclusion: string;
    remitente: Usuario;
    fechaCreado: Date;
    fechaVencimiento: Date;
    formulario: Formulario;
    formularios: PersonaFormulario[];
    nombreBeneficiario: string;
    UUID: string;
    destinatarios: Destinatario[];
    tipoOperacion: TipoOperacion;
    sectorIndustrial: SectorActividad;
    monto: number;
    moneda: Moneda;
    pais: Pais;
    beneficiarioPersonaFisica: PersonaFisica;
    beneficiarioPersonaJuridica: PersonaJuridica;
    beneficiario: any;
    tiposFormulario: string;
    calculoFactorDeRiesgo: number;

    /**
     * Constructor
     *
     * @param DebidaDiligencia
     */
    constructor(DebidaDiligencia)
    {
        {
            this.id = DebidaDiligencia.id || null;
            this.UUID = DebidaDiligencia.UUID || DebidaDiligencia.uuid || '';
            this.nombre = DebidaDiligencia.nombre || '';
            this.conclusion = DebidaDiligencia.conclusion || '';
            this.nombreBeneficiario = DebidaDiligencia.nombreBeneficiario || '';
            this.estado = DebidaDiligencia.estado || 'PRE_INICIADO';
            this.tipo = DebidaDiligencia.tipo || null;
            this.responsable = DebidaDiligencia.responsable || null;
            this.remitente = DebidaDiligencia.remitente || null;
            this.fechaCreado = DebidaDiligencia.fechaCreado || new Date();
            this.cliente = DebidaDiligencia.cliente;
            this.fechaVencimiento = DebidaDiligencia.fechaVencimiento || null;
            this.formulario = DebidaDiligencia.formulario || null;
            this.formularios = DebidaDiligencia.formularios || [];
            this.destinatarios = DebidaDiligencia.destinatarios || [];
            this.tipoOperacion = DebidaDiligencia.tipoOperacion || null;
            this.sectorIndustrial = DebidaDiligencia.sectorIndustrial || null;
            this.monto = DebidaDiligencia.monto || null;
            this.moneda = DebidaDiligencia.moneda || null;
            this.pais = DebidaDiligencia.pais || null;
            this.beneficiarioPersonaFisica = DebidaDiligencia.beneficiarioPersonaFisica || null;
            this.beneficiarioPersonaJuridica = DebidaDiligencia.beneficiarioPersonaJuridica || null;
            this.tiposFormulario = DebidaDiligencia.tiposFormulario || '';
            this.calculoFactorDeRiesgo = DebidaDiligencia.calculoFactorDeRiesgo || 0;
        }
    }
}
